import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MapContainer } from "react-leaflet";
import ControlLayer from "../components/layers/ControlLayer";
import PaneInitializer from "../components/modules/PaneInitializer";
import "leaflet/dist/leaflet.css";
import '../styles/MapPage.css'
import '../styles/Controls.css'
import PrintControl from "../components/controls/PrintControl";
import DateControl from "../components/controls/DateControl";
import StatusDialControl from "../components/controls/StatusDialControl";
import StatementsControl from "../components/controls/StatementsControl";
import Popup from "../components/popups/Popup";
import Modal from "../components/modals/Modal";
import MeasureControl from "../components/controls/MeasureControl";
import Notification from "../components/notifications/Notification";
import ExecutionControl from "../components/controls/ExecutionControl";
// import Test360 from "../components/controls/Test360";
import TasksControlButton from "../components/controls/buttons/TasksControlButton";
import StatisticControlButton from "../components/controls/buttons/StatisticControlButton";
import LayersControlButton from "../components/controls/buttons/LayersControlButton";
import SearchControlButton from "../components/controls/buttons/SearchControlButton";
import TpFilterControlButton from "../components/controls/buttons/TpFilterControlButton";
import AccountingSheetTableButton from "../components/controls/buttons/AccountingSheetTableButton";
import ConclusionsTableButton from "../components/controls/buttons/ConclusionsTableButton";
import RulesTableButton from "../components/controls/buttons/RulesTableButton";
import BindingErrorsButton from "../components/controls/buttons/BindingErrorsButton";
import StageSelectControl from "../components/controls/StageSelectControl";
import { setDrawing } from "../store/reducers/helpersReducer";
import { SetView } from "../components/SetView";
import { preloadPillarsCommonIcons } from "../components/layers/LayerPillars";
import LocationControl from "../components/controls/LocationControl";



const MapPage = () => {
    console.log('MapPage')
    const dispatch = useDispatch()
    const [map, setMap] = useState(null);
    const user = useSelector(state => state.state.user)
    

  

    // Изменение заголовка вкладки браузера при загрузке страницы карты
    useEffect(() => {
        // if (localStorage.getItem('version') !== v) {
        //     localStorage.clear()
        //     clearCacheData()
        //     localStorage.setItem('version', v)
        // }

        document.title = "Авторский надзор";

        preloadPillarsCommonIcons()

        // Возвращаем исходный заголовок при размонтировании компонента
        // return () => {
        //     document.title = "Ситуацяи к КОМОКС";
        // };

       

    }, []);

    // function fetchGrid() {
    //     if (map) {
    //         const bound = map.getBounds()
    //         const top = bound.getNorth().toString().substring(0, 5).replace('.', '')
    //         const bottom = bound.getSouth().toString().substring(0, 5).replace('.', '')
    //         const left = bound.getWest().toString().substring(0, 5).replace('.', '')
    //         const right = bound.getEast().toString().substring(0, 5).replace('.', '')
    //         const zoom = map.getZoom()
    //         dispatch(fetchStateGrid({ top, bottom, left, right, zoom }));

    //     }
    // }

    // useEffect(() => {
    //     // fetchGrid()

    //     const newContainer = document.createElement("div");
    //     newContainer.classList.add("left-top-controls-container");
    //     document.body.appendChild(newContainer)
    //     return () => {
    //         if (document.body.contains(newContainer)) {
    //             document.body.removeChild(newContainer);
    //         }
    //     };
    // }, [])

    // useEffect(() => {
    //     if (map) {
    //         setCurrentBounds(map.getBounds())
    //         // map.addControl(new MeasureControl(measureOptions));
    //     }

    // }, [map])

    useEffect(() => {
        if (!map) return
        
        // Panes теперь создаются в PaneInitializer компоненте внутри MapContainer
        // Этот useEffect оставлен для дополнительных обработчиков событий
        
        map.on('signal:drawing', (data) => {
            console.log(data)
            const pane = map.getPane('drawingPane')
            if (data.state) {
                if (pane) pane.style.pointerEvents = !(data.source === 'kanban' && data.mode === 'points') ? 'auto' : 'none'
                dispatch(setDrawing({ state: true, source: data.source, mode: data.mode }))
            } else {
                if (pane) pane.style.pointerEvents = 'none'
                dispatch(setDrawing({ state: false, source: data.source, mode: data.mode }))
            }
        })

        // Cleanup
        return () => {
            map.off('signal:drawing');
        }
    }, [map, dispatch])




    return (
        <div className="map-page" id="map-page" style={{ display: 'flex', flex: 1, height: '100%', position: 'relative' }}>

            <MapContainer
                center={[43.0, 47.0]}
                zoom={8}
                scrollWheelZoom={true}
                attributionControl={false}
                ref={setMap}
                preferCanvas={true}
                zoomControl={false}
                maxZoom={20}
                // zoomDelta={0.2}
                // zoomSnap={0.2}
                wheelPxPerZoomLevel={500}
                style={{
                    backgroundColor: 'white'
                }}




            >
                <PaneInitializer />
                <ControlLayer />

                {/* TOP LEFT */}
                <LayersControlButton />
                {!user.roles.includes('viewer') && <StatisticControlButton />}
                <StageSelectControl />
                
                {!user.roles.includes('viewer') && <TasksControlButton />}
                <SearchControlButton />
                <TpFilterControlButton />
                <AccountingSheetTableButton />
                <ConclusionsTableButton />
                {!user.roles.includes('viewer') && <RulesTableButton />}
                <LocationControl /> 
                
                {/* <BindingErrorsButton />  */}


                {/* TOP RIGHT */}
                <StatementsControl />
                {/* <StatementsUpdateControl /> */}

                {/* TOP CENTER */}
                <DateControl />


                {/* BOTTOM LEFT */}
                <MeasureControl />
                <ExecutionControl />
                <PrintControl />
                {/* Основной компонент с базовыми настройками */}
                {/* <LeafletDrawWrapper

                    position="bottomleft"
                    enabledTools={['polyline', 'polygon', 'marker']}
                    onDrawCreated={(e) => console.log('Создано:', e)}
                /> */}

                {/* BOTTOM RIGHT */}
                <StatusDialControl />






                {/* <PerformanceMonitor />
                <ProcessingProgressBar position="top-center" /> */}
                {/* <ProgressRingWidget /> */}


                {/* Кнопка управления задачами */}



                {/* Основная панель управления задачами */}

                <Popup />
                <Modal />
                <SetView />
                <Notification />
            </MapContainer>


            <div className="map-controls" id="map-controls" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 1000,
                pointerEvents: 'none'
            }}>
                <div id="map-controls-pane" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', padding: '10px' }}></div>
                <div
                    id="map-controls-grid"
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        // padding: '10px',
                        // display: 'grid',
                        // gridTemplateColumns: 'repeat(2, 1fr)',
                        // gridTemplateRows: 'repeat(2, 1fr)',
                        // gap: '10px',
                        pointerEvents: 'none'
                    }}
                >
                    <div id="map-controls-left-top" 
                        style={{ 
                            position: 'absolute',
                            left: '10px',
                            top: '10px',
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: '10px', 
                            order: 0, 
                            pointerEvents: 'none', 
                            width: 'fit-content',
                            height: 'fit-content'
                        }}
                    >
                        <div id="map-controls-left-top-first-row" style={{ display: 'flex', flexDirection: 'row', gap: '10px', order: 0, pointerEvents: 'none', width: 'fit-content' }}></div>
                        <div id="map-controls-left-top-second-row" style={{ display: 'flex', flexDirection: 'row', gap: '10px', order: 1, pointerEvents: 'none', width: 'fit-content' }}></div>
                        
                    </div>
                    <div id="map-controls-right-top" 
                        style={{ 
                            position: 'absolute',
                            right: '10px',
                            top: window.innerWidth < 768 ? '46px' :'10px',
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: '10px', 
                            order: 0, 
                            pointerEvents: 'none', 
                            width: 'fit-content',
                            height: 'fit-content'
                        }}
                    >
                    </div>
                    <div id="map-controls-left-bottom"
                        style={{ 
                            position: 'absolute',
                            left: '10px',
                            width: window.innerWidth < 768 ? '95vw' : '',
                            bottom: '10px',
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: window.innerWidth < 768 ? 0 : '10px', 
                            order: 0, 
                            pointerEvents: 'none', 
                            width: 'fit-content',
                            height: 'fit-content'
                        }}
                    >
                        <div id="map-controls-left-bottom-first-row" style={{ display: 'flex', alignItems: 'end', flexDirection: 'row', gap: '10px', order: 0, pointerEvents: 'none', width: '95vw', justifyContent: 'space-between' }}>
                            <div id="map-controls-left-bottom-first-row-left" style={{ display: 'flex', justifyContent: 'end', flexDirection: 'column', gap: '10px', order: 0, pointerEvents: 'none', width: 'fit-content', height: 'fit-content' }}></div>
                            <div id="map-controls-left-bottom-first-row-right" style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', flexDirection: 'column', gap: '10px', order: 1, pointerEvents: 'none', width: 'fit-content', height: 'fit-content' }}></div>
                        </div>
                        <div id="map-controls-left-bottom-second-row" style={{ display: 'flex', flexDirection: 'row', gap: '10px', order: 1, pointerEvents: 'none', width: 'fit-content' }}></div>
                    </div>
                    <div id="map-controls-right-bottom" 
                        style={{ 
                            position: 'absolute',
                            right: '10px',
                            bottom: '10px',
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: '10px', 
                            order: 0, 
                            pointerEvents: 'none', 
                            width: 'fit-content',
                            height: 'fit-content',
                            alignItems: 'end'
                        }}
                    >
                    </div>
                </div>
            </div>


        </div >
    )
}

export default MapPage